import { useState } from 'react';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Something went wrong');
        return;
      }
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>Check your email</h1>
          <p style={styles.body}>If an account exists for <strong>{email}</strong>, a password reset link has been sent. Check your inbox and spam folder.</p>
          <p style={styles.body}>The link expires in 30 minutes.</p>
          <a href="/" style={styles.link}>Back to sign in</a>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Forgot password</h1>
        <p style={styles.subtitle}>Enter your email and we will send you a reset link.</p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button style={loading ? styles.buttonDisabled : styles.button} type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <a href="/" style={styles.backLink}>Back to sign in</a>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' },
  card: { backgroundColor: '#fff', padding: '40px', borderRadius: '8px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
  title: { fontSize: '24px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' },
  subtitle: { fontSize: '14px', color: '#666', marginBottom: '24px' },
  body: { fontSize: '14px', color: '#444', marginBottom: '12px', lineHeight: 1.6 },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' },
  input: { width: '100%', padding: '12px', marginBottom: '16px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px', display: 'block', boxSizing: 'border-box' },
  button: { width: '100%', padding: '12px', backgroundColor: '#c0392b', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' },
  buttonDisabled: { width: '100%', padding: '12px', backgroundColor: '#999', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600' },
  link: { display: 'block', marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#c0392b' },
  backLink: { display: 'block', marginTop: '16px', textAlign: 'center', fontSize: '14px', color: '#666' },
};

export default ForgotPassword;
